import React from 'react'
import PropTypes from 'prop-types'
import {
  getCategories,
  getLastSelectedCategory
} from '../../../../redux/selectors/planCategories'
import { getCategoryRelationships } from '../../../../redux/selectors/planCategoryPlanSubcategories'
import {
  removeCategoryFilter,
  addSubcategoryFilter,
  addSeriesFilter,
  removeSeriesFilter,
  removeSubcategoryFilter,
  setDifficultyFilter,
  setIntensityFilter,
  clearDifficultyFilter,
  clearIntensityFilter,
  applyCategoryFilter,
  setProductOrder,
  clearAllSeriesFilters
} from '../../../../redux/actions/products/filters'
import { loadProductsPage } from '../../../../redux/actions/products/products'
import { setSelectedCategorySlug } from '../../../../redux/actions/planCategories'
import { connect } from 'react-redux'

import {
  getCategoryObj,
  getSubcategoryObj
} from '../browseBy/exploreFilterHelpers'

import {
  getDifficultyIcon,
  getIntensityIcon,
  getTotalNumberOfFilters
} from '../../classFinder/classFinderHelperMethods'

// Filter Components
import FilterRowDropdown from '../../../filtersRow/FilterRowDropdown'
import FilterRowDropdownItem from '../../../filtersRow/FilterRowDropdownItem'

import CategoryFilters from './CategoryFilters'
import FilterMetaLayout from '../../../filtersRow/FilterMetaLayout'
import FilterLabelsRow from '../../../filtersRow/FilterLabelsRow'

import { class_series_finder_filter_event } from 'gtm/pushEvents'

class ExploreNav extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      categoryDropdownOpen: false,
      groupDropdownOpen: false,
      activeCategory: '',
      toBeOpenDropdown: '',
      instructorDropDown: false,
      filterModal: false
    }

    this.buildSeriesPageFilterOptions =
      this.buildSeriesPageFilterOptions.bind(this)
    // this.buildSubcategoryFilterOptions =
    //   this.buildSubcategoryFilterOptions.bind(this)
    this.buildFilteredLabels = this.buildFilteredLabels.bind(this)
    this.allSelected = this.allSelected.bind(this)
    this.subcategoryAlreadyFiltered = this.subcategoryAlreadyFiltered.bind(this)
    // this.getTotalNumberOfFilters = this.getTotalNumberOfFilters.bind(this)
    this.clearAllFilters = this.clearAllFilters.bind(this)
    this.areMoreThanOneInstructorAvailable = this.areMoreThanOneInstructorAvailable.bind(this)
  }

  allSelected(category) {
    const subcategories = this.props.filters.categories[category?.slug]
    return subcategories === 'all'
  }

  subcategoryAlreadyFiltered(subcategory) {
    const parentCategory = subcategory.parentCategory
    const subcategories = this.props.filters.categories[parentCategory] || []
    return subcategories.includes(subcategory.slug)
  }

  categoriesAlreadyFiltered(category, item) {
    const categories = this.props.filters[category] || []
    return categories.some((list) => {
      if (typeof list === 'string') {
        return list === item
      } else {
        return list.slug === item.slug
      }
    })
    //return categories.includes(item.slug)
  }

  buildSeriesPageFilterOptions() {
    let filterObj = {}

    ;(filterObj['sort'] = {
      renderDropdownContent: () => {
        return (
          <FilterRowDropdown
            open={this.state.activeCategory === 'sort'}
            dropdownOptions={[
              { title: 'Newest', value: 'date' },
              { title: 'Most Popular', value: 'rank' },
              { title: 'A to Z', value: 'az' }
            ]}
            filterName={'sort'}
            onAfterClose={() => {
              if (this.state.toBeOpenDropdown) {
                const activeCategory = this.state.toBeOpenDropdown
                this.setState({
                  activeCategory,
                  toBeOpenDropdown: ''
                })
              }
            }}
            renderDropdownItemTemplate={({ option }) => {
              return (
                <FilterRowDropdownItem
                  active={this.props.order === option.value}
                  label={option.title}
                  handleItemClick={() => {
                    this.props.setProductOrder(option.value)
                    this.props.loadProductPage(
                      true,
                      this.props.onAfterProductLoad
                    )
                  }}
                  isSort={true}
                />
              )
            }}
          />
        )
      },
      onClickFilterDropdown: (value) => {
        if (
          this.state.activeCategory !== '' &&
          this.state.activeCategory !== value
        ) {
          this.setState({
            toBeOpenDropdown: value,
            activeCategory: ''
          })
        } else {
          const activeValue = this.state.activeCategory === value ? '' : value
          this.setState({ activeCategory: activeValue })
        }
      },
      filterValue: 'sort',
      displayedLabel: 'Sort By'
    }),
      this.props.categories.forEach((category) => {
        filterObj[category.title] = {
          renderDropdownContent: () => {
            return (
              <FilterRowDropdown
                open={this.state.activeCategory === category.slug}
                dropdownOptions={category.planSubcategories
                  .toRefArray()
                  .map((subcategory) => ({
                    parentCategory: category.slug,
                    ...subcategory
                  }))}
                onCheckAll={() => {
                  if (this.allSelected(category)) {
                    this.props.setLastSelectedCategory()
                    this.props.removeCategoryFilter(category.slug)
                  } else {
                    this.props.applyCategoryFilter(category.slug)
                    this.props.setLastSelectedCategory(category.slug)
                  }
                  this.props.loadProductPage(
                    true,
                    this.props.onAfterProductLoad
                  )
                }}
                allOptionsSelected={this.allSelected(category)}
                filterName={category.title}
                onAfterClose={() => {
                  if (this.state.toBeOpenDropdown) {
                    const activeCategory = this.state.toBeOpenDropdown
                    this.setState({
                      activeCategory,
                      toBeOpenDropdown: ''
                    })
                  }
                }}
                renderDropdownItemTemplate={({ option }) => {
                  return (
                    <FilterRowDropdownItem
                      active={this.subcategoryAlreadyFiltered(option)}
                      label={option.title}
                      handleItemClick={() => {
                        if (this.subcategoryAlreadyFiltered(option)) {
                          this.props.removeSubcategoryFilter(
                            category.slug,
                            option.slug
                          )
                        } else {
                          this.props.addSubcategoryFilter(category.slug, option)
                        }
                        this.props.setLastSelectedCategory(category.slug)
                        this.props.loadProductPage(
                          true,
                          this.props.onAfterProductLoad
                        )
                      }}
                    />
                  )
                }}
              />
            )
          },
          onClickFilterDropdown: (categorySlug) => {
            if (category.planSubcategories.count() > 0) {
              if (
                this.state.activeCategory !== '' &&
                this.state.activeCategory !== categorySlug
              ) {
                this.setState({
                  toBeOpenDropdown: categorySlug,
                  activeCategory: ''
                })
              } else {
                const activeValue =
                  this.state.activeCategory === categorySlug ? '' : categorySlug
                this.setState({ activeCategory: activeValue })
              }
            } else {
              if (this.allSelected(category)) {
                this.props.removeCategoryFilter(categorySlug)
              } else {
                this.props.applyCategoryFilter(categorySlug)
              }
              this.props.setLastSelectedCategory(categorySlug)
              this.props.loadProductPage(true, this.props.onAfterProductLoad)
            }
          },
          hasDropdown: category.planSubcategories.count() > 0,
          filterValue: category.slug
        }
      })

    filterObj['focus_area'] = {
      renderDropdownContent: () => {
        return (
          <FilterRowDropdown
            open={this.state.activeCategory === 'focus_area'}
            dropdownOptions={this.props.focusAreaTags}
            filterName={'focus_area'}
            onAfterClose={() => {
              if (this.state.toBeOpenDropdown) {
                const activeCategory = this.state.toBeOpenDropdown
                this.setState({
                  activeCategory,
                  toBeOpenDropdown: ''
                })
              }
            }}
            renderDropdownItemTemplate={({ option }) => {
              return (
                <FilterRowDropdownItem
                  active={this.categoriesAlreadyFiltered('focus_area', option)}
                  label={option}
                  handleItemClick={() => {
                    if (this.categoriesAlreadyFiltered('focus_area', option)) {
                      this.props.removeSeriesFilter('focus_area', option)
                    } else {
                      this.props.addSeriesFilter('focus_area', option)
                    }
                    this.props.setLastSelectedCategory('focus_area')
                    this.props.loadProductPage(
                      true,
                      this.props.onAfterProductLoad
                    )
                  }}
                />
              )
            }}
          />
        )
      },
      onClickFilterDropdown: (value) => {
        if (
          this.state.activeCategory !== '' &&
          this.state.activeCategory !== value
        ) {
          this.setState({
            toBeOpenDropdown: value,
            activeCategory: ''
          })
        } else {
          const activeValue = this.state.activeCategory === value ? '' : value
          this.setState({ activeCategory: activeValue })
        }
      },
      filterValue: 'focus_area',
      displayedLabel: 'Focus Area'
    }

    filterObj['equipment'] = {
      renderDropdownContent: () => {
        return (
          <FilterRowDropdown
            open={this.state.activeCategory === 'equipment'}
            dropdownOptions={this.props.equipmentTags}
            filterName={'equipment'}
            onAfterClose={() => {
              if (this.state.toBeOpenDropdown) {
                const activeCategory = this.state.toBeOpenDropdown
                this.setState({
                  activeCategory,
                  toBeOpenDropdown: ''
                })
              }
            }}
            renderDropdownItemTemplate={({ option }) => {
              return (
                <FilterRowDropdownItem
                  active={this.categoriesAlreadyFiltered('equipment', option)}
                  label={option}
                  handleItemClick={() => {
                    if (this.categoriesAlreadyFiltered('equipment', option)) {
                      this.props.removeSeriesFilter('equipment', option)
                    } else {
                      this.props.addSeriesFilter('equipment', option)
                    }
                    this.props.setLastSelectedCategory('equipment')
                    this.props.loadProductPage(
                      true,
                      this.props.onAfterProductLoad
                    )
                  }}
                />
              )
            }}
          />
        )
      },
      onClickFilterDropdown: (value) => {
        if (
          this.state.activeCategory !== '' &&
          this.state.activeCategory !== value
        ) {
          this.setState({
            toBeOpenDropdown: value,
            activeCategory: ''
          })
        } else {
          const activeValue = this.state.activeCategory === value ? '' : value
          this.setState({ activeCategory: activeValue })
        }
      },
      filterValue: 'equipment'
    }

    filterObj['difficulties'] = {
      renderDropdownContent: () => {
        return (
          <FilterRowDropdown
            open={this.state.activeCategory === 'difficulties'}
            dropdownOptions={[
              'introductory',
              'beginner',
              'moderate',
              'intermediate',
              'advanced'
            ]}
            filterName={'difficulties'}
            filterDesc='Difficulty refers to the level of skill and technique called for.'
            onAfterClose={() => {
              if (this.state.toBeOpenDropdown) {
                const activeCategory = this.state.toBeOpenDropdown
                this.setState({
                  activeCategory,
                  toBeOpenDropdown: ''
                })
              }
            }}
            renderDropdownItemTemplate={({ option }) => {
              const filteredDifficulties = this.props.filters.difficulties
              return (
                <FilterRowDropdownItem
                  active={filteredDifficulties.includes(option)}
                  label={option}
                  itemStyles={{ width: '65%' }}
                  itemClassName={['difficultyFilterItem']}
                  handleItemClick={() => {
                    if (
                      this.categoriesAlreadyFiltered('difficulties', option)
                    ) {
                      this.props.removeSeriesFilter('difficulties', option)
                    } else {
                      this.props.addSeriesFilter('difficulties', option)
                    }
                    this.props.setLastSelectedCategory('difficulties')
                    this.props.loadProductPage(
                      true,
                      this.props.onAfterProductLoad
                    )
                  }}
                  renderDecorator={() => getDifficultyIcon(option)}
                />
              )
            }}
          />
        )
      },
      onClickFilterDropdown: (value) => {
        if (
          this.state.activeCategory !== '' &&
          this.state.activeCategory !== value
        ) {
          this.setState({
            toBeOpenDropdown: value,
            activeCategory: ''
          })
        } else {
          const activeValue = this.state.activeCategory === value ? '' : value
          this.setState({ activeCategory: activeValue })
        }
      },

      filterValue: 'difficulties',
      displayedLabel: 'Difficulty'
    }
    filterObj['intensities'] = {
      renderDropdownContent: () => {
        return (
          <FilterRowDropdown
            open={this.state.activeCategory === 'intensities'}
            dropdownOptions={['1', '2', '3', '4']}
            filterName={'intensities'}
            filterDesc='Intensity refers to the amount of exertion required.'
            onAfterClose={() => {
              if (this.state.toBeOpenDropdown) {
                const activeCategory = this.state.toBeOpenDropdown
                this.setState({
                  activeCategory,
                  toBeOpenDropdown: ''
                })
              }
            }}
            renderDropdownItemTemplate={({ option }) => {
              const filteredIntensities = this.props.filters.intensities
              return (
                <FilterRowDropdownItem
                  active={filteredIntensities.includes(option)}
                  itemStyles={{ width: '32%' }}
                  itemClassName={['intensityFilterItem']}
                  label={option}
                  handleItemClick={() => {
                    if (this.categoriesAlreadyFiltered('intensities', option)) {
                      this.props.removeSeriesFilter('intensities', option)
                    } else {
                      this.props.addSeriesFilter('intensities', option)
                    }
                    this.props.setLastSelectedCategory('intensities')
                    this.props.loadProductPage(
                      true,
                      this.props.onAfterProductLoad
                    )
                  }}
                  renderDecorator={() => getIntensityIcon(option)}
                />
              )
            }}
          />
        )
      },
      onClickFilterDropdown: (value) => {
        if (
          this.state.activeCategory !== '' &&
          this.state.activeCategory !== value
        ) {
          this.setState({
            toBeOpenDropdown: value,
            activeCategory: ''
          })
        } else {
          const activeValue = this.state.activeCategory === value ? '' : value
          this.setState({ activeCategory: activeValue })
        }
      },

      filterValue: 'intensities',
      displayedLabel: 'Intensity'
    }
    if (this.areMoreThanOneInstructorAvailable()) {
      filterObj['instructors'] = {
        renderDropdownContent: () => {
          return (
            <FilterRowDropdown
              open={this.state.activeCategory === 'instructors'}
              dropdownOptions={this.props.instructorOptions}
              filterName={'instructors'}
              onAfterClose={() => {
                if (this.state.toBeOpenDropdown) {
                  const activeCategory = this.state.toBeOpenDropdown
                  this.setState({
                    activeCategory,
                    toBeOpenDropdown: ''
                  })
                }
              }}
              renderDropdownItemTemplate={({ option }) => {
                const user = option.user
                return (
                  <FilterRowDropdownItem
                    active={this.categoriesAlreadyFiltered('instructors', option)}
                    label={`${user.firstName} ${user.lastName}`}
                    handleItemClick={() => {
                      if (this.categoriesAlreadyFiltered('instructors', option)) {
                        this.props.removeSeriesFilter('instructors', option.slug)
                      } else {
                        this.props.addSeriesFilter('instructors', option)
                      }
                      this.props.setLastSelectedCategory('instructors')
                      this.props.loadProductPage(
                        true,
                        this.props.onAfterProductLoad
                      )
                    }}
                  />
                )
              }}
            />
          )
        },
        onClickFilterDropdown: (value) => {
          if (
            this.state.activeCategory !== '' &&
            this.state.activeCategory !== value
          ) {
            this.setState({
              toBeOpenDropdown: value,
              activeCategory: ''
            })
          } else {
            const activeValue = this.state.activeCategory === value ? '' : value
            this.setState({ activeCategory: activeValue })
          }
        },
        filterValue: 'instructors'
      }
      
    }
    

    return filterObj
  }

  buildFilteredLabels() {
    let filteredItems = {}
    const filteredCategories = this.props.filters.categories

    for (const categorySlug in filteredCategories) {
      const subcategorySlugs = filteredCategories[categorySlug]
      const category = getCategoryObj(this.props.categories, categorySlug)
      if (this.allSelected(category)) {
        let text = category.title
        const categorySubcategories = category.subcategories || []
        if (categorySubcategories.length > 0) {
          text = `All ${text}`
        }
        filteredItems[category.slug] = [
          {
            text,
            meta: category.slug
          }
        ]
      } else {
        filteredItems[categorySlug] = subcategorySlugs?.map(
          (subcategorySlug) => {
            const subcategory = getSubcategoryObj(
              category.subcategories,
              subcategorySlug
            )
            let text = ''
            const numberOfParentCategories = this.props.categoryRelationships
              .filter((categorySubcategory) => {
                const subcategorySlug =
                  categorySubcategory.toPlanSubcategoryId.split('_')[1]
                const subcategoryToCompareSlug = subcategory.slug.split('_')[1]
                return subcategorySlug === subcategoryToCompareSlug
              })
              .count()
            if (numberOfParentCategories > 1) {
              text = `${category.title}:`
            }
            return {
              text: text + subcategory.title,
              meta: subcategory.slug
            }
          }
        )
      }
      if (this.props.filters.instructors) {
        const instructorFilter = this.props.filters.instructors.map((item) => {
          return {
            text: `${item?.user?.firstName} ${item?.user?.lastName}`,
            meta: item.slug
          }
        })
        filteredItems['instructors'] = instructorFilter
      }
      if (this.props.filters['focus_area']) {
        const focusAreaFilter = this.props.filters['focus_area'].map((item) => {
          return {
            text: item,
            meta: item
          }
        })
        filteredItems['focus_area'] = focusAreaFilter
      }
      if (this.props.filters.equipment) {
        const equipmentFilter = this.props.filters.equipment.map((item) => {
          return {
            text: item,
            meta: item
          }
        })
        filteredItems['equipment'] = equipmentFilter
      }

      if (this.props.filters.difficulties) {
        const difficlutyFilter = this.props.filters.difficulties.map((item) => {
          return {
            text: `${item}`,
            meta: item
          }
        })
        filteredItems['difficulties'] = difficlutyFilter
      }
      if (this.props.filters.intensities) {
        const intensityFilter = this.props.filters.intensities.map((item) => {
          return {
            text: `Level ${item}`,
            meta: item
          }
        })
        filteredItems['intensities'] = intensityFilter
      }
    }

    return filteredItems
  }

  userHasFiltered() {
    return !!this.props.filters.difficulty || !!this.props.filters.intensity
  }

  // getTotalNumberOfFilters(filteredLabels) {
  //   let activeFilters = []
  //   for (const filter in filteredLabels) {
  //     // if (filteredLabels && !this.excludedFilters.includes(filter)) {
  //     const filteredItem = filteredLabels[filter]
  //     filteredItem?.map((label, idx) => {
  //       activeFilters.push(label)
  //     })
  //     // }
  //   }
  //   return activeFilters.length
  // }

  clearAllFilters() {
    this.props.clearAllSeriesFilters()
    this.props.loadProductPage(true, this.props.onAfterProductLoad)
  }

  areMoreThanOneInstructorAvailable() {
    return this.props?.instructorOptions?.length > 1
  }

  render() {
    const filterOptions = this.buildSeriesPageFilterOptions()
    // const subcategoryFilterOptions = this.buildSubcategoryFilterOptions()
    const filteredLabels = this.buildFilteredLabels()
    // const difficultyIntensityOptions = this.buildDifficultyIntensityOptions()
    const totalfiltersSelected = getTotalNumberOfFilters(filteredLabels)

    return (
      <FilterMetaLayout
        filters={filterOptions}
        // onModalClear={(label) => {
        //   if (label === 'difficulty') {
        //     this.props.clearDifficultyFilter()
        //   } else if (label === 'intensity') {
        //     this.props.clearIntensityFilter()
        //   }
        //   this.props.loadProductPage(true, this.props.onAfterProductLoad)
        // }}
        onFixed={() => {
          this.setState({ activeCategory: '' })
        }}
        onLayoutSelect={this.props.selectLayout}
        layout={this.props.layout}
        modalFilterOptions={filterOptions}
        userHasFiltered={this.userHasFiltered()}
        totalProducts={this.props.totalProducts}
        order={this.props.order}
        sortableFields={['rank', 'az', 'date']}
        contentLabel='Series'
        onSort={(order) => {
          this.props.setProductOrder(order)
          this.props.loadProductPage(true, this.props.onAfterProductLoad)
        }}
        renderTopRow={() => (
          <FilterLabelsRow
            filterOptions={filterOptions}
            activeDropdown={this.state.activeCategory}
            // excludedFilters={this.excludedFilters}
          />
        )}
        renderMobileFilters={true}
        totalfiltersSelected={totalfiltersSelected}
        onClearAll={this.clearAllFilters}
        filteredLabels={filteredLabels}
        onSelectedFilterLabelClick={(parentCategorySlug, slug) => {
          if (
            parentCategorySlug == 'instructors' ||
            parentCategorySlug == 'equipment' ||
            parentCategorySlug == 'focus_area' ||
            parentCategorySlug == 'difficulties' ||
            parentCategorySlug == 'intensities'
          ) {
            this.props.removeSeriesFilter(parentCategorySlug, slug)
          } else {
            const isACategory = Object.keys(
              this.props.filters.categories
            ).includes(slug)

            if (isACategory) {
              this.props.removeCategoryFilter(slug)
            } else {
              this.props.removeSubcategoryFilter(parentCategorySlug, slug)
            }
          }
          this.props.loadProductPage(true, this.props.onAfterProductLoad)
        }}
      />
    )
  }
}

ExploreNav.propTypes = {
  addSubcategoryFilter: PropTypes.func,
  categoryRelationships: PropTypes.object,
  clearDifficultyFilter: PropTypes.func,
  setDifficultyFilter: PropTypes.func,
  setIntensityFilter: PropTypes.func,
  clearIntensityFilter: PropTypes.func,
  removeCategoryFilter: PropTypes.func,
  removeSubcategoryFilter: PropTypes.func,
  categories: PropTypes.array,
  setLastSelectedCategory: PropTypes.func,
  filters: PropTypes.object,
  presentedCategory: PropTypes.object,
  group: PropTypes.string,
  layout: PropTypes.string,
  onSort: PropTypes.func,
  order: PropTypes.string,
  applyCategoryFilter: PropTypes.func,
  selectLayout: PropTypes.func,
  totalProducts: PropTypes.number,
  loadProductPage: PropTypes.func,
  onAfterProductLoad: PropTypes.func,
  setProductOrder: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    categories: getCategories(state),
    categoryRelationships: getCategoryRelationships(state),
    presentedCategory: getLastSelectedCategory(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setLastSelectedCategory: (newCategorySlug) => {
      dispatch(setSelectedCategorySlug(newCategorySlug))
    },
    addSubcategoryFilter: (parentCategory, filter) => {
      class_series_finder_filter_event(parentCategory, filter?.slug)
      dispatch(addSubcategoryFilter(parentCategory, filter))
    },
    addSeriesFilter: (parentCategory, filter) => {
      class_series_finder_filter_event(parentCategory, filter)
      dispatch(addSeriesFilter(parentCategory, filter))
    },
    removeSeriesFilter: (parentCategory, filter) => {
      dispatch(removeSeriesFilter(parentCategory, filter))
    },
    removeCategoryFilter: (filterSlug) => {
      dispatch(removeCategoryFilter(filterSlug))
    },
    removeSubcategoryFilter: (
      parentCategory,
      filterSlug,
      clearParent = true
    ) => {
      dispatch(removeSubcategoryFilter(parentCategory, filterSlug, clearParent))
    },
    setDifficultyFilter: (difficulty) => {
      dispatch(setDifficultyFilter(difficulty))
    },
    clearDifficultyFilter: () => {
      dispatch(clearDifficultyFilter())
    },
    setIntensityFilter: (intensity) => {
      dispatch(setIntensityFilter(intensity))
    },
    clearIntensityFilter: () => {
      dispatch(clearIntensityFilter())
    },
    loadProductPage: (reloadAll, callback) => {
      dispatch(loadProductsPage(reloadAll, callback))
    },
    applyCategoryFilter: (category) => {
      dispatch(applyCategoryFilter(category))
    },
    setProductOrder: (order) => {
      dispatch(setProductOrder(order))
    },
    clearAllSeriesFilters: () => {
      dispatch(clearAllSeriesFilters())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ExploreNav)
